// import { environment } from './../../../../environments/environment';
import { Injectable } from '@angular/core';
import { AxiosService } from 'src/app/core/axios';
import { environment } from 'src/environments/environment';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AvataresService {
  private api = environment.apiUrl;
  private selectedAvatar$ = new BehaviorSubject<string>(
    localStorage.getItem('selectedAvatar') || 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSVCSMkWaF4ReLMfiRu3NXk12zJikhfSx0bSQ&s',
  );

  constructor(private axios: AxiosService) {
    // do nothing
  }

  async getAvatares() {
    const result = await this.axios.get(`${this.api}avatares`);
    return result;
  }

  // Método para obtener el avatar seleccionado como Observable
  getSelectedAvatar(): Observable<string> {
    return this.selectedAvatar$.asObservable();
  }

  // Método para actualizar el avatar seleccionado
  updateSelectedAvatar(avatarUrl: string) {
    localStorage.setItem('selectedAvatar', avatarUrl);
    this.selectedAvatar$.next(avatarUrl);
  }
}
